import React, { useEffect } from "react";
import { matchPath, useLocation, useParams } from "react-router-dom";
import GameModeLayout from "../components/GameModeLayout";
import Routes from "../../../routes/Routes";
import { GameRoutes } from "../../../routes/game-routes";
import { useGameContext } from "../../../state/game/context";
import { useAppContext } from "../../../state/app/context";
import { useStreamContext } from "../../../state/stream/context";

const GameModeLayoutContainer = () => {
	const { pathname } = useLocation();
	// const match = matchPath({ path: baseURL }, pathname);
	// const { eventId } = match.params;

	const { eventId } = useParams();

	const streamMode =
		GameRoutes.STREAM.url.replace(":eventId", eventId) === pathname;

	const { state: appState } = useAppContext();
	const gameMenuItems = appState.gameMenuItems();

	const enableMenu =
		Object.values(GameRoutes).filter(
			(route) =>
				route.showMenu &&
				matchPath(
					{
						path: route.url,
						exact: true,
						strict: true
					},
					pathname
				)
		).length > 0;

	const { initGameData } = useGameContext();
	const { initStreamData } = useStreamContext();

	useEffect(() => {
		if (eventId) {
			if (streamMode) {
				initStreamData(eventId);
			} else {
				initGameData(eventId);
			}
		}
	}, [eventId]);

	return (
		<GameModeLayout
			enableMenu={enableMenu}
			menuItems={gameMenuItems}
			router={<Routes routeConfig={GameRoutes} />}
		/>
	);
};

// GameModeLayoutContainer.whyDidYouRender = true;

export default GameModeLayoutContainer;
